var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading',{ref:"loading",attrs:{"fullPage":"true","active":_vm.loading,"can-cancel":false,"color":_vm.colorLoading,"height":_vm.heightLoading,"width":_vm.widthLoading},on:{"update:active":function($event){_vm.loading=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }